/* unplugin-vue-components disabled */import script from "./auditReject.vue?vue&type=script&lang=ts&setup=true"
export * from "./auditReject.vue?vue&type=script&lang=ts&setup=true"

import "./auditReject.vue?vue&type=style&index=0&id=53461238&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53461238"]])

export default __exports__